import { Controller } from "stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    this.tooltips = []
    const tooltipElements = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipElements.forEach((el) => {
      this.tooltips.push(new Tooltip(el))
    })
  }

  disconnect() {
    this.tooltips.forEach((tooltip) => {
      tooltip.dispose()
    })
    this.tooltips = []
  }
}
